import styled from 'styled-components';

export const ListDischargeSiloContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  margin: 1rem 0 2rem 0;
`;
